export default from './icon-button';



// WEBPACK FOOTER //
// ./app/components/icon-button/index.js